import type {
    WordId,
    SentenceId,
    Timestamp,
    IntervalMs
} from '$lib/classes/data/_primitives';

export enum Status {
    Known = 'KNOWN',
    Learn = 'LEARN',
}

export class UserWord {

    constructor(
        public readonly id: WordId,
        public readonly status: Status,
        public readonly sentenceId: SentenceId | null,
        public readonly added: Timestamp,
        public readonly toLearnNext: Timestamp,
        public readonly interval: IntervalMs = 54000000,
    ) {
    }

    private copy(changes: Partial<Omit<UserWord, 'added'>>): UserWord {
        return new UserWord(
            changes.id ?? this.id,
            changes.status ?? this.status,
            changes.sentenceId === undefined ? this.sentenceId : changes.sentenceId,
            this.added,
            changes.toLearnNext ?? this.toLearnNext,
            changes.interval ?? this.interval
        );
    }

    withId(newId: WordId): UserWord {
        return this.copy({id: newId});
    }

    withStatus(status: Status): UserWord {
        return this.copy({status});
    }

    withSentenceId(sentenceId: SentenceId | null): UserWord {
        return this.copy({sentenceId});
    }

    withToLearnNextAndInterval(toLearnNext: Timestamp, interval: IntervalMs): UserWord {
        return this.copy({toLearnNext, interval});
    }
}